import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../../base-modal/base-modal.component";
import {UploadProgressService} from "../../../../services/upload-progress.service";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {
  AttachFileParams,
  AttachFileToRecord,
  OpenFilesViewerModalParams,
  RecordCalendarFileParams
} from "../../../../types/file.types";
import {SingleFilesParamsService} from "../services/single-files-params.service";
import {FilesCurrentService} from "../services/files-current.service";
import {FileCardComponent} from "../../../../../shared/components/ui/file-card/file-card.component";
import {MultiFilesParamsService} from "../services/multi-files-params.service";
import {RecordCalendarFilesService} from "../../../../services/record-calendar-files.service";
import {FileUploadCardComponent} from "../../../../../shared/components/ui/file-upload-card/file-upload-card.component";
import {singleTypeFilesViewerModalName} from "../configs/single-type-files-viewer-config";
import {CurrentUserRoleAndLogin} from "../../../../types/auth.types";
import {LoaderComponent} from "../../../../../shared/components/loader/loader.component";

@Component({
  selector: 'app-single-type-files-viewer-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    FileCardComponent,
    FileUploadCardComponent,
    LoaderComponent,
  ],
  templateUrl: './single-type-files-viewer-modal.component.html',
  styleUrl: './single-type-files-viewer-modal.component.scss'
})
export class SingleTypeFilesViewerModalComponent extends BaseModalComponent {
  public uploadProgressService: UploadProgressService = inject(UploadProgressService);
  public dialogData = inject<OpenFilesViewerModalParams>(MAT_DIALOG_DATA);
  public singleFilesParamsService: SingleFilesParamsService = inject(SingleFilesParamsService);
  private filesCurrentService: FilesCurrentService = inject(FilesCurrentService);
  private multiFilesParamsService: MultiFilesParamsService = inject(MultiFilesParamsService);
  private recordCalendarFilesService: RecordCalendarFilesService = inject(RecordCalendarFilesService);
  private recordCalendarFilesServiceService: RecordCalendarFilesService = inject(RecordCalendarFilesService);

  public loginAndRoles: CurrentUserRoleAndLogin | null = null;

  public override async ngOnInit() {
    super.ngOnInit();
    this.modalStatesService.openModal(singleTypeFilesViewerModalName);
    !this.dialogData.isAllFiles && await this.getFilesParams();
    this.loginAndRoles = this.authService.getRolesAndLogin();
  }

  public override ngOnDestroy(): void {
    this.modalStatesService.closeModal(singleTypeFilesViewerModalName);
    this.editModeService.setEditMode(this.dialogData.isEditMode || false);
    this.singleFilesParamsService.resetFilesData();
  }

  public getTitle(): string {
    return `Файлы '${this.dialogData.title}'`;
  }

  public async getFilesParams(): Promise<void> {
    this.loadingService.setIsLoadingState(true);
    await this.filesCurrentService.getFilesParams(this.dialogData).finally(() =>
      setTimeout(() => {
        this.loadingService.setIsLoadingState(false);
      }, 300)
    );
  }

  public async handleDelete(isImage: boolean, recordCalendarFileParams: RecordCalendarFileParams): Promise<void> {
    this.recordCalendarFilesService.deleteFileToRecord(recordCalendarFileParams.id)
      .then(() => {
        this.dialogData.isAllFiles ?
          this.multiFilesParamsService.deleteMultiFileParams(recordCalendarFileParams.type, recordCalendarFileParams.id) :
          this.singleFilesParamsService.deleteFilesData(recordCalendarFileParams.id);
      });
  }

  public async attachFile({ parentId, fileId, type }: AttachFileParams): Promise<void> {
    const attachFileToRecord: AttachFileToRecord = {
      recordCalendarId: parentId,
      fileId: fileId,
      type: type
    };

    await this.recordCalendarFilesServiceService.attachFileToRecord(attachFileToRecord)
      .then((recordCalendarFileParams) => this.singleFilesParamsService.updateFilesData(recordCalendarFileParams));
  }

  public getEditMode(): boolean {
    if (this.loginAndRoles?.role === 'ROLE_PROMOTION_SPECIALIST') { return false; }

    return this.isEditModeActive;
  }
}
